<div
  [class.ds-filled]="innerValue"
  [class.ds-focus]="hasFocus"
  class="d-flex flex-nowrap align-items-stretch form-control__wrapper"
>
  <div
    [class.ds-disabled]="isDisabled"
    [class.ds-filled]="innerValue"
    [class.ds-focus]="hasFocus"
    [class.ds-invalid]="showError"
    [class.form-control--addition]="iconName"
    class="form-control"
  >
    <input
      #innerInput
      (blur)="setHasFocus(false);onBlur();"
      (focus)="setHasFocus(true)"
      (input)="onChange()"
      [(ngModel)]="innerValue"
      [class.ds-display-tooltip]="!!tooltipContent"
      [disabled]="isDisabled"
      [attr.aria-label]="label"
      [type]="type"
      class="form-control--input p-0 float-left"
    />
    <ds-tooltip *ngIf="tooltipContent"
      [content]="tooltipContent"
      [placement]="tooltipPlacement"
      [ariaLabel]="tooltipAriaLabel"
      [title]="tooltipTitle">
    </ds-tooltip>
    <ds-input-label
      *ngIf="label && !isDisabled"
      [for]="fieldName"
      [label]="label">
    </ds-input-label>
    <ds-input-placeholder
      [hideWhenFilled]="hidePlaceholderWhenFilled"
      [hideWhenFocused]="hidePlaceholderWhenFocused"
      [placeholder]="placeholder"
      [placeholderRemark]="placeholderRemark"
    ></ds-input-placeholder>
  </div>

  <span *ngIf="showClearButton && innerValue" class="clear form-control form-control__icon">
    <ds-input-icon (click)="clearInput()" class='clear-btn' [iconName]="'close'"></ds-input-icon>
  </span>
  <ds-input-icon *ngIf="iconName" [iconName]="iconName"></ds-input-icon>
</div>
<ds-input-error [error]="error" [showError]="showError"></ds-input-error>
